import React, { useEffect } from 'react'
import { Control, useWatch } from 'react-hook-form'

const typedMemo: <T>(c: T) => T = React.memo
export const FormValuesWatcher = typedMemo(FormValuesWatcherInner)
function FormValuesWatcherInner<T>({
  control,
  onValuesChange,
}: {
  control?: Control<T>
  onValuesChange: (values: T) => void
}) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const values = useWatch({ control: (control as unknown) as any })

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onValuesChange(values as any)
  }, [values, onValuesChange])

  return null
}
